module.exports = __webpack_public_path__ + "media/4x3/gg-98f67a6f.svg";